/**
 * This function brings log messages into a uniform structure and enriches them with the current page ID.
 * @param {string} id - ID of the current page
 * @param {string} message - log message
 * @returns formatted message
 */
function formatMessage(id, message) {
    return `[${id}] - ${message}`;
}

export { formatMessage };
